// extracted by css-extract-rspack-plugin
export default {"cls1":"SocialProofFadeFooter-cls1_O2Z","cls2":"SocialProofFadeFooter-cls2_PlH SocialProofFadeFooter-cls1_O2Z"};